import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import StatisticsScreen from "../screens/StatisticsScreen";
import SkillAnalyticsDetail from "../components/statistics/SkillAnalyticsDetail";
import EvaluationAnalyticsDetail from "../components/statistics/EvaluationAnalyticsDetail";
import QuestionAnalyticsDetail from "../components/statistics/QuestionAnalyticsDetail";

type StatisticsRouterProps = RouteComponentProps;

const StatisticsRouter: React.FC<StatisticsRouterProps> = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}`} exact component={StatisticsScreen} />
      <Route
        path={`${match.path}/skills/:id`}
        exact
        component={SkillAnalyticsDetail}
      />
      <Route
        path={`${match.path}/evaluations/:id`}
        exact
        component={EvaluationAnalyticsDetail}
      />
      <Route
        path={`${match.path}/questions/:id`}
        exact
        component={QuestionAnalyticsDetail}
      />
    </Switch>
  );
};

export default StatisticsRouter;
